import actions from '../actions/actionTypes';
import { mapSelectedItems } from '../utils';

export const INITIAL_STATE = {
  selectedItems: [],
  filteredBy: [],
  loading: false,
  notificationsItems: [],
  count: null,
  error: null,
};

export const notificationsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.NOTIFICATIONS_APPLY_FILTER:
      return {
        ...state,
        filteredBy: payload,
      };
    case actions.NOTIFICATIONS_SELECT:
      return {
        ...state,
        selectedItems: mapSelectedItems(payload, state.selectedItems),
      };
    case actions.NOTIFICATIONS_UNSELECT_ALL:
      return {
        ...state,
        selectedItems: [],
      };
    case actions.NOTIFICATIONS_GET_ITEMS_LOADING:
    case actions.NOTIFICATIONS_GET_FILTERED_ITEMS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.NOTIFICATIONS_GET_ITEMS_SUCCESS:
    case actions.NOTIFICATIONS_GET_FILTERED_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationsItems: [...state.notificationsItems, ...payload.notificationsItems],
        count: payload.count,
      };
    case actions.NOTIFICATIONS_GET_ITEMS_ERROR:
    case actions.NOTIFICATIONS_GET_FILTERED_ITEMS_ERROR:
    case actions.NOTIFICATIONS_UPDATE_ITEM_READ_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actions.NOTIFICATIONS_UPDATE_ITEM_READ_SUCCESS:
      return {
        ...state,
        notificationsItems: payload,
      };
    case actions.NOTIFICATIONS_CLEAR_ITEMS:
      return {
        notificationsItems: INITIAL_STATE.notificationsItems,
        count: INITIAL_STATE.count,
        error: INITIAL_STATE.error,
      };
    default:
      return state;
  }
};

export default notificationsReducer;
